import React, { useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import { AlertTriangle, X } from "react-feather";

import "./internal-attachments.scss";

const AUTO_DISMISS_MS = 6000;

/** Feedback de validação de anexo, exibido dentro da própria janela do chat.
 *  Não usa toast de propósito: o chat interno é uma sidebar presente em todas as
 *  telas, e o `toast()` do react-toastify 5 é entregue a TODOS os ToastContainer
 *  montados. Como várias telas montam o seu, o aviso apareceria duplicado.
 */
const InternalAttachmentErrors = ({ errors, onDismiss }) => {
    /** `onDismiss` costuma chegar como arrow inline, com identidade nova a cada render.
     *  Se ele entrasse nas dependências, o timer reiniciaria a cada render do chat e o
     *  aviso ficaria na tela indefinidamente enquanto a conversa estivesse ativa.
     */
    const onDismissRef = useRef(onDismiss);
    onDismissRef.current = onDismiss;

    useEffect(() => {
        if (!errors || errors.length === 0) return undefined;
        const timer = setTimeout(() => onDismissRef.current(), AUTO_DISMISS_MS);
        return () => clearTimeout(timer);
    }, [errors]);

    const intl = useIntl();

    if (!errors || errors.length === 0) return null;

    return (
        <div className="internal-attachment-errors-ui">
            <div className="internal-attachment-errors-icon">
                <AlertTriangle size={16} />
            </div>
            <ul className="internal-attachment-errors-list">
                {errors.map((error, index) => (
                    <li key={`internal-attachment-error-${index}`}>
                        {intl.formatMessage({ id: error.id }, error.values)}
                    </li>
                ))}
            </ul>
            <span role="button" className="internal-attachment-errors-close" onClick={onDismiss}>
                <X size={14} />
            </span>
        </div>
    );
}

export default InternalAttachmentErrors;
